module.exports = __webpack_public_path__ + "green1.ad276c6a.png";